import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgClickOutsideDirective } from 'ng-click-outside2';

import { PlessDialogService } from './pless-dialog-service';
import { PlessTitleWindowDirective } from './pless-title-window.directive';
import { PlessAlertComponent } from './pless-alert/pless-alert.component';
import { PlessBlockLayerService } from './http/pless-block-layer.service';
import { PlessHttp } from './http/pless-http.service';
import { PlessInputTextDirective } from './input/pless-input-text.directive';
import { GetMessagesService } from './get-messages.service';
import { CommaPipe } from './comma.pipe';
import { DeleteCommaPipe } from './delete-comma.pipe';
import { SuffixPipe } from './suffix.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgClickOutsideDirective,
    DragDropModule
  ],
  exports: [
    PlessInputTextDirective,
    PlessTitleWindowDirective,
    CommaPipe,
    DeleteCommaPipe,
    SuffixPipe,
    DragDropModule,
  ],
  declarations: [
    PlessAlertComponent,
    PlessInputTextDirective,
    PlessTitleWindowDirective,
    CommaPipe,
    DeleteCommaPipe,
    SuffixPipe,
  ],
  providers: [
    NgbActiveModal,
    PlessBlockLayerService,
    PlessDialogService,
    PlessHttp,
    GetMessagesService,
  ],
})

/** 共通機能を管理するモジュール */
export class PlessSharedModule { }
